export default __webpack_public_path__ + "static/media/image.bevylabs.b2247a35.png";